import { supabase } from "@/lib/supabase";
import {
  analyticsDashboardResponseSchema,
  EMPTY_ANALYTICS_DASHBOARD,
  type AnalyticsDashboardData,
} from "@/types/analytics";

class AnalyticsService {
  private static instance: AnalyticsService;

  private constructor() {}

  public static getInstance(): AnalyticsService {
    if (!AnalyticsService.instance) {
      AnalyticsService.instance = new AnalyticsService();
    }
    return AnalyticsService.instance;
  }

  public async getDashboard(
    startDate: string,
    endDate: string,
  ): Promise<AnalyticsDashboardData> {
    const { data, error } = await supabase.rpc("get_analytics_dashboard", {
      start_dt: startDate,
      end_dt: endDate,
    });

    if (error) {
      console.error("Error loading analytics data:", error);
      throw new Error(error.message);
    }

    const parsed = analyticsDashboardResponseSchema.safeParse(data);
    if (!parsed.success) {
      console.error("Invalid analytics dashboard response:", parsed.error);
      return EMPTY_ANALYTICS_DASHBOARD;
    }

    return parsed.data;
  }
}

export const analyticsService = AnalyticsService.getInstance();
